import { render, staticRenderFns } from "./AnnouncementsConsole.vue?vue&type=template&id=5da1ef15&scoped=true&"
import script from "./AnnouncementsConsole.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsConsole.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsConsole.vue?vue&type=style&index=0&id=5da1ef15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1ef15",
  null
  
)

export default component.exports